import { jsx as A } from "react/jsx-runtime";
import { useMediaQuery as D, Drawer as d } from "@mui/material";
import { DEFAULT_DRAWER_WIDTH as R, DEFAULT_DRAWER_DESKTOP_ANCHOR as _, DEFAULT_DRAWER_MOBILE_ANCHOR as a, DEFAULT_DRAWER_TEST_ID as h } from "./constants17.mjs";
import { useTheme as T } from "styled-components";
import { MOBILE_SCREEN as c } from "./screens.mjs";
import { AnchorToBorderRadius as f } from "./constants18.mjs";
const w = (e) => {
  const {
    children: t,
    onClose: s,
    desktopWidth: i = R,
    desktopAnchor: m = _,
    mobileAnchor: o = a,
    testId: E = h,
    ...n
  } = e, p = T(), r = D(p.breakpoints.down(c));
  return /* @__PURE__ */ A(
    d,
    {
      ...n,
      anchor: r ? o : m,
      onClose: s,
      "data-testid": E,
      PaperProps: {
        sx: r ? {
          maxHeight: "85%",
          ...f[o]
        } : {
          width: i
        }
      },
      children: t
    }
  );
};
export {
  w as DrawerV2
};
//# sourceMappingURL=index31.mjs.map
